'use client';import React from 'react';

var PlasmicDataSourceContext = /*#__PURE__*/React.createContext(undefined);
function usePlasmicDataSourceContext() {
  return React.useContext(PlasmicDataSourceContext);
}
function useCurrentUser() {
  var _ctx$user;
  var ctx = usePlasmicDataSourceContext();
  return (_ctx$user = ctx == null ? void 0 : ctx.user) != null ? _ctx$user : {
    isLoggedIn: false
  };
}
var PlasmicDataSourceContextProvider = PlasmicDataSourceContext.Provider;

export { PlasmicDataSourceContextProvider, useCurrentUser, usePlasmicDataSourceContext };
//# sourceMappingURL=data-sources-context.esm.js.map
